module.exports = __webpack_public_path__ + "img/Car-danger.66320914.svg";